import type { FC } from 'react'

import { cn } from '@/lib/utils'
import { formatRange } from '@/lib/hours'
import { useBakeryClock } from '@/hooks/use-bakery-clock'

import { OPENING_HOURS } from '@/constants/site'

interface HoursListProps {
    className?: string
}

// The full week, with today marked once the bakery's local date is known.
export const HoursList: FC<HoursListProps> = ({ className }) => {
    const now = useBakeryClock()

    return (
        <table className={cn('w-full border-collapse text-[0.9375rem]', className)}>
            <caption className='sr-only'>ساعات کاری</caption>

            <tbody>
                {OPENING_HOURS.map(day => {
                    const isToday = now?.weekday === day.day

                    return (
                        <tr key={day.day} className='border-b border-line first:border-t' aria-current={isToday ? 'date' : undefined}>
                            <th scope='row' className='py-3.5 text-start font-normal'>
                                <span className={cn('transition-colors duration-500', isToday ? 'font-medium text-foreground' : 'text-foreground')}>
                                    {day.name}
                                </span>

                                {isToday && (
                                    <span className='ms-3 label-caps text-amber'>
                                        امروز
                                    </span>
                                )}
                            </th>

                            <td className={cn('py-3.5 text-end tabular-nums', day.open ? 'text-foreground' : 'text-crust-soft', isToday && 'font-medium')}>
                                {formatRange(day)}
                            </td>
                        </tr>
                    )
                })}
            </tbody>
        </table>
    )
}
